// ©2024 Austin App House. All rights reserved.
import React from 'react';
// removed MDBReact usage
import ContractorCertificatesChecks from '../../layout/ContractorCertificatesChecks';

const detailsBlockStyles = { padding: '25px 0px 0px 15px' };

const ContractorDetailsAdditional = ({
  contractorDetails = null,
}) => (
  <>
    {
      contractorDetails.about
        ? (
          <div className="about_user">
            <div className="profile_label">Bio / About:</div>
            <div
              className="profile_info"
              dangerouslySetInnerHTML={{ __html: contractorDetails.about !== 'undefined' ? contractorDetails.about : '' }}
            />
          </div>
        )
        : null
    }
    {
      contractorDetails.credentials
        ? (
          <div className="about_user">
            <div className="profile_label">Credentials:</div>
            <div
              className="profile_info"
              dangerouslySetInnerHTML={{ __html: contractorDetails.credentials !== 'undefined' ? contractorDetails.credentials : '' }}
            />
          </div>
        )
        : null
    }
    {
      contractorDetails.certificates
        ? (
          <div className="certifications_section">
            <div className="profile_label">Certifications:</div>
            <ContractorCertificatesChecks
              certificates={contractorDetails.certificates}
              infoType="name"
              size="100%"
            />
          </div>
        )
        : null
    }
    {
      contractorDetails.groups.length
        ? (
          <>
            <div className="preferred_groups">
              <div className="profile_label">Preferred groups:</div>
              <div className="groups_list">
                {contractorDetails.groups.map((group, index) => (
                  <span key={index} className="group_tag">{group}</span>
                ))}
              </div>
            </div>
          </>
        )
        : null
    }
    {
      contractorDetails.other_tools
        ? (
          <div className="about_user">
            <div className="profile_label">Other types of work I can do:</div>
            <div
              className="profile_info"
              dangerouslySetInnerHTML={{ __html: contractorDetails.other_tools !== 'undefined' ? contractorDetails.other_tools : '' }}
            />
          </div>
        )
        : null
    }
  </>
);

export default ContractorDetailsAdditional;
